import React, {FC, memo} from 'react';
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

export interface LinkProps {
  pathname: string;
  linkName: string;
  current: boolean;
  classNames?: string;
  children?: React.ReactNode;
  isParent?: boolean;
  isChild?: boolean;
  onClick?: () => void;
}

const LinkContainer = memo(styled.div`
  .group .stroke-current {
    color: rgb(55 65 81);
  }
  .group:hover .stroke-current {
    color: white;
  }
`);

const getLinkContainerClassName = (
  current: boolean,
  classNames: string,
  isChild: boolean,
) => {
  const commonClasses = `group flex items-center lg:justify-center xl:justify-start rounded-full gap-x-2 xl:px-4 xl:w-full mb-1 mx-auto text-lg leading-snug cursor-pointer ${classNames}`;
  if (isChild) {
    return classnames(`${commonClasses} lg:w-[39px] h-[39px] lg:px-0`, {
      'text-blue-600 bg-blue-100': current,
      'text-gray-600 hover:text-blue-600': !current,
    });
  }

  return classnames(`${commonClasses} lg:w-[50px] h-[50px] `, {
    'text-white bg-blue-600': current,
    'text-gray-600 hover:text-blue-600': !current,
  });
};

export const NavLinkV2: FC<LinkProps> = ({
  pathname,
  current,
  linkName,
  children,
  classNames = '',
  isParent = false,
  isChild = false,
  onClick,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  if (isParent && !pathname) {
    return (
      <div
        className={getLinkContainerClassName(current, classNames, isChild)}
        onClick={onClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={linkName}
      >
        <div className="w-7 h-auto lg:flex justify-center items-center xl:block">
          {children}
        </div>
        <span
          className={`lg:hidden xl:block text-base font-normal ${
            linkName.toLowerCase() === 'share' ? 'text-white' : ''
          }`}
        >
          {linkName}
        </span>
      </div>
    );
  }
  // If it's a child, add indentation
  return (
    <Link
      to={pathname}
      className={classnames('flex justify-center xl:justify-start')}
    >
      <LinkContainer
        className={getLinkContainerClassName(current, classNames, isChild)}
      >
        {!isChild ? (
          <div className="w-7 h-auto lg:flex justify-center items-center xl:block">
            {children}
          </div>
        ) : (
          <div className="xl:hidden w-7 h-auto lg:flex justify-center items-center">
            {linkName
              .split(' ')
              .map(word => word[0])
              .join('')}
          </div>
        )}
        <span
          className={`lg:hidden xl:block text-base font-normal ${
            linkName.toLowerCase() === 'share' ? 'text-white' : ''
          }`}
        >
          {linkName}
        </span>
      </LinkContainer>
    </Link>
  );
};
